import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);


    const normalizeProfileImage = (userData) => {
    if (userData?.profile_image && !userData.profile_image.startsWith("http")) {
      userData.profile_image = `https://blasterprime.com${userData.profile_image}`;
    }
    return userData;
  };

  const login = (userData, token, rememberMe = false) => {
    console.log('🔐 LOGIN CALLED:', { 
      userData: userData?.email, 
      rememberMe,
      hasToken: !!token
    });

    userData = normalizeProfileImage(userData);
    localStorage.clear();
    sessionStorage.clear();
    setCurrentUser(userData);
    
    // ⚠️ PERBAIKAN: Clear BOTH storage terlebih dahulu
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    
    setCurrentUser(userData);
    
    // ⚠️ PERBAIKAN: Simpan BOTH token dan user BERSAMAAN
    if (rememberMe) {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      console.log('💾 Saved to localStorage');
    } else {
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('user', JSON.stringify(userData));
      console.log('💾 Saved to sessionStorage');
    }
  };

  const logout = () => {
    console.log('🚪 LOGOUT CALLED');
    setCurrentUser(null);
    // Hapus dari SEMUA storage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  };

    useEffect(() => {
    console.log('🔄 Load user from storage...');
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const user = localStorage.getItem('user') || sessionStorage.getItem('user');

      if (token && user) {
        const userData = normalizeProfileImage(JSON.parse(user));
        setCurrentUser(userData);
      }
    } catch (err) {
      console.error('Auth load error:', err);
      setCurrentUser(null);
    } finally {
      setIsLoading(false);
    }
  }, []);


  // ✅ Dengarkan event profileUpdated dari EditProfile.jsx
  useEffect(() => {
    const handleProfileUpdated = () => {
      console.log("🌀 AuthContext detected profile update event...");
      try {
        const storedUser = localStorage.getItem("user") || sessionStorage.getItem("user");
        if (storedUser) {
          const parsedUser = normalizeProfileImage(JSON.parse(storedUser));
          setCurrentUser(parsedUser);
          console.log("✅ AuthContext updated currentUser:", parsedUser);
        }
      } catch (err) {
        console.error("💥 Failed to update user:", err);
      }
    };

    window.addEventListener("profileUpdated", handleProfileUpdated);
    return () => window.removeEventListener("profileUpdated", handleProfileUpdated);
  }, []);


  return (
    <AuthContext.Provider value={{ currentUser, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}